import { ComponentProperty } from "./_component-property.t";

export class Component implements ComponentProperty {
    elementRef: string;
    element: JQuery<HTMLElement> | any;
    name: string;
}